module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo3-62ac147ea62b8e50cb691e5072642bd1.png";